import type { Store } from '@/Domain/entities/Store';

export const stores: Store[] = [
  {
    id: 1,
    name: 'Paris Iquique',
    brand: 'paris',
    address: {
      id: 1,
      region: 1,
      alias: 'home',
      commune: '10304',
      // eslint-disable-next-line quotes
      streetName: "Av. O'Higgins",
      streetNumber: '581',
      firstName: '?',
      lastName: '?',
      apartment: '?',
      phone: '1111111'
    },
    availableDate: '10 de enero',
    infoLabel: '2 de tus productos están aquí'
  },
  {
    id: 2,
    name: 'Jumbo Iquique',
    brand: 'jumbo',

    address: {
      id: 2,
      region: 1,
      alias: 'work',
      commune: '10304',
      // eslint-disable-next-line quotes
      streetName: "Av. O'Higgins",
      streetNumber: '581',
      firstName: '?',
      lastName: '?',
      apartment: '?',
      phone: '1111111'
    },
    availableDate: '10 de enero'
  },
  {
    id: 3,
    name: 'Paris Antofagasta',
    brand: 'paris',
    address: {
      id: 3,
      region: 2,
      alias: 'home 2',
      commune: '20301',
      // eslint-disable-next-line quotes
      streetName: "Av. O'Higgins",
      streetNumber: '581',
      firstName: '?',
      lastName: '?',
      apartment: '?',
      phone: '1111111'
    },
    availableDate: '10 de enero',
    infoLabel: '2 de tus productos están aquí'
  },
  {
    id: 4,
    name: 'Jumbo Antofagasta',
    brand: 'jumbo',
    address: {
      id: 4,
      region: 2,
      alias: 'work 2',
      commune: '20301',
      // eslint-disable-next-line quotes
      streetName: "Av. O'Higgins",
      streetNumber: '581',
      firstName: '?',
      lastName: '?',
      apartment: '?',
      phone: '1111111'
    },
    availableDate: '10 de enero'
  }
];
